export default __webpack_public_path__ + "static/media/step1_poi_image.ac022214.jpg";